<template>
  <div class="layout__header flex flex--align-center flex--justify-between" :shadow="showShadow">
    <div class="layout__header__logo">
      <img src="../../assets/common/logo.png"/>
    </div>
    
    <template v-if="$route.meta.type === 'static'">
      <div class="layout__header__msg">
        <router-link to="/faq">
          <v-icon type="iconlocal_phone-24px" right-text="联系我们"></v-icon>
        </router-link>
      </div>
      
      <div class="layout__header__menu-btn" @click="handleSwitchMenuVisible">
        <v-icon type="iconmenu-24px" right-text="菜单"></v-icon>
      </div>
    </template>

    <template v-else-if="token">
      <div class="layout__header__msg">
        <b v-if="unreadTotal > 0" class="badge"></b>
        <v-icon type="iconnotifications-24px1"
                @click.native="handleSwitchMessageListVisible"></v-icon>
      </div>
      <div class="layout__header__menu-btn" @click="handleSwitchMenuVisible">
        <v-icon type="iconmenu-24px" right-text="菜单"></v-icon>
      </div>
    </template>
    <LayoutMenu></LayoutMenu>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex';
import LayoutMenu from './layoutMenu.vue';


export default {
  name: 'layoutHeader',
  components: {
    LayoutMenu,
  },
  data() {
    return {
      showShadow: false
    }
  },
  computed: {
    ...mapState(['token']),
    ...mapState('user', ['full_name', 'menuList']),
    ...mapState('message', ['messages', 'unreadTotal']),
  },
  methods: {
    ...mapMutations(['clearSession', 'updateState']),
    handleSwitchMenuVisible() {
      this.updateState({
        menuVisible: true,
      });
    },
    handleSwitchMessageListVisible() {
      this.updateState({
        messageListVisible: true,
      });
    },
  },
  mounted() {
    window.addEventListener('scroll', e => {
      const scrollTop = window.pageYOffset
        || document.documentElement.scrollTop
        || document.body.scrollTop
        || 0;
      this.showShadow = scrollTop > 30;
    });
  }
};
</script>

<style lang="less">
  @prefix: ~"layout";
  .@{prefix} {
    &__header{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 48px;
      background-color: rgb(81, 69, 139);
      padding-left: 16px;
      z-index: 99;

      &[shadow] {
        box-shadow: 0 24px 38px 3px rgba(0,0,0,0.10), 0 9px 46px 8px rgba(0,0,0,0.08), 0 11px 15px 0 rgba(0,0,0,0.16);
      }

      &__logo{
        height: 40px;
        // cursor: pointer;
        img{
          height: 40px;
          width: auto;
        }
      }
      &__msg{
        text-align: right;
        flex: 1;
        padding-right: 24px;
        position: relative;
        .badge{
          position: absolute;
          right: 25px;
          width: 6px;
          top: -3px;
          height: 6px;
          border-radius: 3px;
          background-color: rgb(100, 255, 218);
        }
        .v-icon{
          color: #fff;
          vertical-align: middle;
          cursor: pointer;
        }
        span{
          vertical-align: middle;
        }
      }
      &__menu-btn{
        width: 110px;
        padding-left: 27px;
        flex-basis: 110px;
        height: 48px;
        border-left: 1px solid rgba(255,255,255, .16);
        line-height: 48px;
        color: #fff;
        cursor: pointer;
        .v-icon{
          color: #fff;
          margin-right: 8px;
          vertical-align: baseline;
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .layout__header {
      & .icon-right-text {
        display: none;
      }
      & .layout__header__menu-btn {
        width: 48px;
        padding-left: 12px;
        flex-basis: 48px;
        line-height: 48px;
        .v-icon{
          margin-right: 0;
        }
      }
      & .layout__header__msg {
        padding-right: 12px;
      }
    }
  }
</style>
